import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Entfernt ein führendes "Objekt " aus Namen (z.B. "Objekt Max Mustermann" -> "Max Mustermann"). */
export function stripObjektPrefix(value?: string | null): string {
  const v = (value ?? "").trim();
  if (!v) return "";
  return v.replace(/^objekt\s+/i, "").trim();
}

